<template>
  <div class="video-swiper-module">
    <div v-if="isShowVideo" class="video-wrapper" @mousewheel.stop @click="hideVideo">
      <div class="video" @click.stop :style="{width:videoWidth+'px', height:videoHeight+'px'}" id="video-player">
        <div class="loading">视频加载中...</div>
      </div>
      <img src="../assets/images/svg/Group.svg" alt="" class="close" @click="hideVideo">
    </div>
    <div class="video-swiper-wrapper" @mousewheel.stop>
      <swiper :options="videoSwiperOptions" ref="videoSwiper" @click.native="showVideo()">
        <swiper-slide v-for="(video, i) in data" :key="i">
          <div class="preview-block">
            <div class="preview">
              <img :src="video.previewUrl" alt="">
              <div class="shade-wrapper">
                <div class="shade"></div>
              </div>
              <div class="play-button">
                <img src="../assets/images/png/Group 6@2x.png" alt="">
              </div>
            </div>
            <div class="title" v-html="video.title"></div>
          </div>
        </swiper-slide>
      </swiper>
      <img src="../assets/images/svg/8592.svg" class="video-swiper-button video-swiper-button-prev pc-only"><!--左箭头-->
      <img src="../assets/images/svg/8594.svg" class="video-swiper-button video-swiper-button-next pc-only"><!--右箭头-->
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoSwiper',
  props: {data: Array},
  data () {
    return {
      videoSwiperOptions: {
        navigation: {
          nextEl: '.video-swiper-button-next',
          prevEl: '.video-swiper-button-prev'
        },
        // loop
        loop: true,
        loopedSlides: this.data.length,
        loopAdditionalSlides: 0,
        // 网格
        centeredSlides: true,
        slidesPerView: 3
        // 滚轮
        // mousewheel: true
      },
      isShowVideo: false,
      videoWidth: 925,
      videoHeight: 520
    }
  },
  computed: {
    swiper () {
      return this.$refs.videoSwiper.swiper
    }
  },
  methods: {
    showVideo () {
      let index = (this.swiper.clickedIndex) % this.data.length
      this.isShowVideo = true
      let videoUrl = this.data[index].videoUrl
      this.$nextTick(() => {
        // 获取宽高
        let clientWidth = document.documentElement.clientWidth
        if (clientWidth >= 1200) {
          this.videoWidth = 925
        } else {
          this.videoWidth = clientWidth
        }
        this.videoHeight = this.videoWidth * 1080 / 1920
        let div = document.getElementById('video-player')
        let script = document.createElement('script')
        script.src = videoUrl + `&width=${this.videoWidth}&height=${this.videoHeight}`
        div.appendChild(script)
      })
    },
    hideVideo () {
      this.isShowVideo = false
    }
  },
  mounted () {
  }
}
</script>
<style lang="stylus" scoped>
.video-swiper-module
  position relative
  .video-swiper-button
    position absolute
    top 215px
    width 50px
    border-radius 50%
    height @width
    cursor pointer
    z-index 99
    &.video-swiper-button-next
      right -10px
    &.video-swiper-button-prev
      left -10px

  $img-width = 190px
  $img-width-active = 370px
  $model-height = 428px
  $transition-time = 400ms
  .video-swiper-wrapper
    position relative
    margin 0 auto
    width 1200px
    .swiper-container
      height 520px
      max-width 1200px
      cursor pointer
      .swiper-slide
        position relative
        margin auto
        height 428px
        text-align center
        .preview-block
          position relative
          margin-top 95px
          transition margin-top $transition-time
          .title
            margin-top 20px
            width 100%
            text-align center
            color #fff
            font-size 14px
            line-height 20px
            transition font-size $transition-time, line-height $transition-time
          .preview
            position relative
            width $img-width
            height @width
            margin 0 auto
            transition width $transition-time, height $transition-time
            img
              width $img-width
              height @width
              border-radius 50%
              transition width $transition-time, height $transition-time
            .play-button
              position absolute
              top 50%
              left 50%
              width 80px
              height @width
              transform translate(-@width / 2, -@width / 2)
              border-radius 50%
              background rgba(0, 0, 0, 0.7)
              cursor pointer
              transition width $transition-time, height $transition-time, transform $transition-time, background $transition-time
              &:hover
                background rgba(0, 0, 0, 0.9)
              &:active
                background rgba(0, 0, 0, 1)
              img
                position absolute
                display block
                top 50%
                left 50%
                width 40px
                height @width
                transform translate(-@width / 2, -@width / 2)
                transition width $transition-time, height $transition-time, margin-top $transition-time, transform $transition-time
            .shade-wrapper
              position absolute
              top 0
              left 0
              width $img-width
              text-align center
              .shade
                width $img-width
                height @width
                border-radius 50%
                background rgba(0, 0, 0, 0.2)
                transition width $transition-time, height $transition-time, background $transition-time
        &.swiper-slide-active, &.swiper-slide-duplicate-active
          .preview-block
            position relative
            left 50%
            margin-top 0
            transform translate(- ($img-width-active / 2))
            .title
              font-size 20px
              line-height 28px
              transition font-size $transition-time, line-height $transition-time
            .preview
              position relative
              width $img-width-active
              height @width
              transition width $transition-time, height $transition-time
              img
                width $img-width-active
                height @width
                border-radius 50%
                transition width $transition-time, height $transition-time
            .play-button
              position absolute
              top 50%
              left 50%
              width 150px
              height @width
              transform translate(-@width / 2, -@width / 2)
              background rgba(255, 23, 10, 0.61)
              transition width $transition-time, height $transition-time, transform $transition-time, background $transition-time
              &:hover
                background rgba(255, 23, 10, 0.81)
              &:active
                background rgba(255, 23, 10, 1)
              img
                position absolute
                display block
                top 50%
                left 50%
                width 90px
                height @width
                transform translate(-@width / 2, -@width / 2)
                transition width $transition-time, height $transition-time, margin-top $transition-time, transform $transition-time
            .shade-wrapper
              width $img-width-active
              .shade
                width $img-width-active
                height @width
                background rgba(255, 0, 0, 0.2)
                transition width $transition-time, height $transition-time, background $transition-time
@media screen and (min-width: 1366px)
  .video-swiper-module
    position relative
    .video-swiper-button
      &.video-swiper-button-next
        right -30px
      &.video-swiper-button-prev
        left -30px
@media screen and (min-width: 1600px)
  .video-swiper-module
    position relative
    .video-swiper-button
      &.video-swiper-button-next
        right -70px
      &.video-swiper-button-prev
        left -70px
@media screen and (min-width: 1800px)
  .video-swiper-module
    position relative
    .video-swiper-button
      &.video-swiper-button-next
        right -130px
      &.video-swiper-button-prev
        left -130px
@media screen and (min-width: 1201px)
  .video-wrapper
    position fixed
    top 0
    left 0
    width 100%
    height 100%
    background rgba(255, 255, 255, 0.21)
    pointer-events auto
    z-index 9999
    $video-height = 520px
    $video-width = 925px
    .close
      position absolute
      top 50%
      left 50%
      width 10px
      height @width
      padding 10px
      border-radius 50%
      background rgba(0, 0, 0, 0.71)
      cursor pointer
      transform translate(-(@width / 2px), ((@height + $video-height) / 2px) + 10px)
    .video
      position absolute
      top 50%
      left 50%
      width $video-width
      height $video-height
      background #000
      transform translate(-(@width / 2px), -(@height / 2px))
      .loading
        position absolute
        width 100%
        text-align center
        line-height $video-height
        pointer-events none
        z-index -1
@media screen and (max-width: 1200px)
  .video-wrapper
    position fixed
    top 0
    left 0
    display flex
    justify-content center
    width 100%
    height 100%
    background rgba(0, 0, 0, 0.71)
    pointer-events auto
    z-index 9999
    .close
      position absolute
      top 0.3rem
      right 0.2rem
      width 0.4rem
      height @width
      padding 0.2rem
      border-radius 50%
      background rgba(0, 0, 0, 0.71)
      cursor pointer
    .video
      position relative
      margin auto
      background #000
      .loading
        position absolute
        width 100%
        text-align center
        font-size 0.6rem
        line-height 4rem
  .video-swiper-module
    height 11.26rem
    $img-width = 3.04rem
    $img-width-active = 5.9rem
    $model-height = 8.8rem
    $transition-time = 200ms
    .video-swiper-wrapper
      position absolute
      left -2.1rem
      margin 0
      width 16.2rem
      .swiper-container
        height 11.26rem
        max-width auto
        width 12rem
        cursor pointer
        .swiper-slide
          position relative
          height 7.26rem
          margin auto
          text-align center
          opacity 0
          .preview-block
            position relative
            margin-top 2.9rem
            transition margin-top $transition-time
            .title
              display none
              margin-top 1.44rem
              width 100%
              text-align center
              color #fff
              font-size 0.38rem
              line-height 0.53rem
              transition font-size $transition-time, line-height $transition-time
            .preview
              position relative
              width $img-width
              height @width
              transition width $transition-time, height $transition-time
              img
                width $img-width
                height @width
                border-radius 50%
                transition width $transition-time, height $transition-time
              .play-button
                position absolute
                top 50%
                left 50%
                width 1.28rem
                height @width
                transform translate(-@width / 2, -@width / 2)
                border-radius 50%
                background rgba(0, 0, 0, 0.7)
                cursor pointer
                transition width $transition-time, height $transition-time, transform $transition-time, background $transition-time
                &:hover
                  background rgba(0, 0, 0, 0.9)
                &:active
                  background rgba(0, 0, 0, 1)
                img
                  position absolute
                  display block
                  top 50%
                  left 50%
                  width 0.64rem
                  height @width
                  transform translate(-@width / 2, -@width / 2)
                  transition width $transition-time, height $transition-time, margin-top $transition-time, transform $transition-time
              .shade-wrapper
                position absolute
                top 0
                left 0
                width $img-width
                text-align center
                .shade
                  width $img-width
                  height @width
                  border-radius 50%
                  background rgba(0, 0, 0, 0.2)
                  transition width $transition-time, height $transition-time, background $transition-time
          &.swiper-slide-prev
            opacity 1
            top -1.5rem
            left -1.45rem
            right auto
            transition top $transition-time
          &.swiper-slide-next
            opacity 1
            top -1.5rem
            right -1.45rem
            left auto
            transition top $transition-time
          &.swiper-slide-active
            opacity 1
            top 0
            left unit((12rem - $img-width-active) / 2, 'rem')
            right auto
            transition top $transition-time
          &.swiper-slide-active, &.swiper-slide-duplicate-active
            .preview-block
              .title
                text-align center
                width 5.92rem
                font-size 0.38rem
                line-height 0.53rem
                display block
              .preview
                width $img-width-active
                height @width
                transition width $transition-time, height $transition-time
                img
                  width $img-width-active
                  height @width
                  transition width $transition-time, height $transition-time, margin-top $transition-time, transform $transition-time
              .play-button
                width 2.4rem
                height @width
                transform translate(-@width / 2, -@width / 2)
                background rgba(255, 23, 10, 0.61)
                &:hover
                  background rgba(255, 23, 10, 0.81)
                &:active
                  background rgba(255, 23, 10, 1)
                img
                  position absolute
                  display block
                  top 50%
                  left 50%
                  width 1.44rem
                  height @width
                  transform translate(-@width / 2, -@width / 2)
              .shade-wrapper
                width $img-width-active
                .shade
                  width $img-width-active
                  height @width
                  background rgba(255, 0, 0, 0.2)
</style>



// WEBPACK FOOTER //
// src/components/VideoSwiper.vue